module.exports = __webpack_public_path__ + "img/dc-comics.9ea25726.png";